import React, { useState, useEffect } from 'react'
import { DownOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { Typography, Button, Select, Modal, Row, Col, Dropdown, Menu, Input } from 'antd'

import { toRedactor } from 'super-charged-rte'
import * as themes from '../styles/theme/themeVars'
import * as cssTheme from '../styles/theme/cssVars'
import ColorPicker from './ColorPicker'
import colorFunc from '../styles/customTheme'

const { Text } = Typography

const onCopy = (value) => {
    if (navigator.clipboard !== undefined) {
        navigator.clipboard.writeText(toRedactor(value[0])).then(
            function () {

            },
            function (err) {
                console.error('Async: Could not copy text: ', err)
            }
        )
    } else if (window.clipboardData) {
        window.clipboardData.setData('Text', toRedactor(value[0]))
    }
}
const setStyleCustom = (root) => {
    const customStyle = JSON.parse(localStorage.getItem('styleVariable'))
    if (customStyle?.['cssVariable']) {
        Object.entries({ ...cssTheme['defaultTheme'], ...customStyle['cssVariable'] }).forEach((value) => root.style.setProperty(value[0], value[1]))
    }
    window.less.modifyVars({ ...themes['customTheme'], ...customStyle?.['lessVariable'] })
}

export default (props) => {
    const { Option } = Select
    const { value, uploadDoc, pageProps } = props
    const [isPublishing, setPublishing] = useState(false)
    const [showCustom, setCustom] = useState(false)
    const [displayEditPagePropertyModal, setDisplayEditPagePropertyModal] = useState(false)
    const [displayCustomizeModal, setDisplayCustomizeModal] = useState(false)
    const [color, setColor] = useState({})
    const [cssVariable, setcssVariable] = useState({})
    const [currentPage, setCurrentPage] = useState('')
    const [pageChange, setPageChange] = useState({})
    const colorTheme = colorFunc(JSON.parse(localStorage.getItem('styleVariable')))
    useEffect(() => {
        let id = localStorage.getItem('seletedPageId')
        let index = 0;
        if (id) {
            index = pageProps.userPages.findIndex((val) => val.id === id)
        }
        if (index === -1) {
            index = 0
        }
        if (pageProps?.userPages?.[index]?.title) {
            setCurrentPage(pageProps.userPages[index].title)
        }
    }, [pageProps])

    // const publishHandler = async (e) => {
    //     e.preventDefault()
    //     setPublishing(true)
    //     var myHeaders = new Headers()
    //     myHeaders.append('api_key', 'blt2cf669e5016d5e07')
    //     myHeaders.append('authorization', 'csf9e7a0d0e7e9d04e14215f9a')
    //     myHeaders.append('Content-Type', 'application/json')

    //     var requestOptions = (method, body) => ({
    //         method: method,
    //         headers: myHeaders,
    //         body: body,
    //         redirect: 'follow'
    //     })
    //     const publish = () => {
    //         var raw = JSON.stringify({
    //             entry: { environments: ['development'], locales: ['en-us'] },
    //             locale: 'en-us'
    //         })
    //         fetch(
    //             'https://api.contentstack.io/v3/content_types/home/entries/bltc16de98a6957d1e4/publish',
    //             requestOptions('POST', raw)
    //         )
    //             .then((response) => response.json())
    //             .then((result) => {

    //                 setPublishing(false)
    //             })

    //     }
    //     fetch("https://api.contentstack.io/v3/content_types/home/entries/bltc16de98a6957d1e4", requestOptions('GET'))
    //         .then(response => response.json())
    //         .then(result => {
    //             let newPages = result['entry']['pages']
    //             let newPagesTitle = result['entry']['page_title']
    //             if (newPages && newPagesTitle) {
    //                 newPages.splice(selectedPageProps.selectedPage, 1, toRedactor(value[0]))
    //                 var raw = JSON.stringify({
    //                     entry: { pages: newPages, url: '/', page_title: pagesTitleProps.pagesTitle }
    //                 })
    //                 fetch(
    //                     'https://api.contentstack.io/v3/content_types/home/entries/bltc16de98a6957d1e4',
    //                     requestOptions('PUT', raw)
    //                 )
    //                     .then((response) => response.json())
    //                     .then((result) => {
    //                         publish()
    //                     })
    //             }
    //         })
    //         .catch(error => console.log('error', error));


    // }

    useEffect(() => {
        const value = localStorage.getItem('theme')
        let root = document.documentElement
        let initialColorState = JSON.parse(localStorage.getItem('styleVariable'))
        if (value) {
            if (value === 'customTheme') {
                setStyleCustom(root)
                setCustom(true)
                if (initialColorState) {
                    setColor({ ...initialColorState['lessVariable'] })
                    setcssVariable({ ...initialColorState['cssVariable'] })
                }
                return
            }
            window.less.modifyVars(themes[value])
            const cssStyle = cssTheme[value]
            if (cssStyle) {
                Object.entries(cssStyle).forEach((value) => root.style.setProperty(value[0], value[1]))
            }
        }
    }, [])
    const handleThemeChange = (value) => {
        let root = document.documentElement
        console.log('Theme changed to ', value)
        if (value === 'customTheme') {
            setCustom(true)
            setStyleCustom(root)
            localStorage.setItem('theme', value)
            return
        } else {
            setCustom(false)
        }
        window.less.modifyVars(themes[value])
        const cssStyle = cssTheme[value]
        if (cssStyle) {
            Object.entries(cssStyle).forEach((value) => root.style.setProperty(value[0], value[1]))
        }
        localStorage.setItem('theme', value)
    }
    // const handleDeletePage = () => {
    //     const { index } = currentPage
    //     let newPageTitle = pagesTitleProps.pagesTitle.slice()
    //     newPageTitle.splice(index, 1)
    //     let newPageList = pagesProps.pages.slice()
    //     newPageList.splice(index, 1)
    //     pagesTitleProps.setPagesTitle(newPageTitle)
    //     pagesProps.setPages(newPageList)
    //     if (currentPage.index === selectedPageProps.selectedPage) {

    //         selectedPageProps.setSelectedPageHandler('home')
    //     }
    //     setDisplayEditPagePropertyModal(false)
    // }

    // const menu = (
    //     <Menu>
    //         {pagesProps.pages.map(
    //             (child, index) =>
    //                 (<Menu.Item
    //                     key={index}

    //                 >
    //                     <span
    //                         onClick={() => selectedPageProps.setSelectedPageHandler(pagesTitleProps.pagesTitle[index])}
    //                         style={{ minWidth: '100px', display: 'inline-block', maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{pagesTitleProps.pagesTitle[index]}</span>
    //                     <Button size='small' shape='circle' icon={<i className="ri-settings-5-line" onClick={(event) => {

    //                         setDisplayEditPagePropertyModal(true)
    //                         setCurrentPage({ title: pagesTitleProps.pagesTitle[index], index })
    //                     }}></i>} style={{ marginLeft: 'auto', top: '-4px' }}></Button>
    //                 </Menu.Item>
    //                 )
    //         )
    //         }
    //         <Menu.Item onClick={() => selectedPageProps.setSelectedPageHandler('newPage')}>New Page</Menu.Item>
    //     </Menu>
    // )
    const menu = (
        <Menu>
            {pageProps.userPages.map((child, index) => (
                <Menu.Item
                    key={child.id}
                >
                    <span
                        onClick={() => { pageProps.changePage(child.id) }}
                        style={{ minWidth: '100px', display: 'inline-block', maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis', height: '22px' }}>{child.title}</span>
                    <Button size='small' shape='circle' icon={<i className="ri-settings-5-line" onClick={(event) => {
                        setPageChange(child)
                        setDisplayEditPagePropertyModal(true)
                    }
                    }></i>} style={{ marginLeft: 'auto', top: '-4px' }}></Button>
                </Menu.Item>
            ))}
            <Menu.Item onClick={() => {
                pageProps.createNewPage()

            }}>New Page</Menu.Item>
        </Menu>
    )
    return (
        <div
            className='p-3'
            style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', position: 'relative', padding: '5px' }}
        >
            <Link
                style={{ fontSize: '18px' }}
                to='/preview'
                target='_blank'
            >
                {'<HP/> '}
            </Link>
            <Text
                copyable={{
                    tooltips: ['Copy Redactor Html', 'Copied Redactor Html']
                }}
                onCopy={() => onCopy(value)}
            ></Text>
            <Dropdown overlay={menu} trigger={['click']}>
                <Button size='small' style={{ minWidth: '150px', maxWidth: '150px', marginLeft: '10px', textOverflow: 'ellipsis', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{currentPage}</span> <DownOutlined />
                </Button>
            </Dropdown>
            <Modal
                title="Edit Page"
                visible={displayEditPagePropertyModal}
                onCancel={() => setDisplayEditPagePropertyModal(false)}
                onOk={() => {
                    pageProps.changeTitle(currentPage, pageChange.id)
                    setDisplayEditPagePropertyModal(false)
                }}
            >
                <div style={{ display: 'flex' }}>
                    <Input style={{ display: 'inline-block' }} value={currentPage} onChange={(event) => setCurrentPage(event.target.value)}></Input>
                    <Button style={{ display: 'inline-block', marginLeft: '5px' }} icon={<i className="ri-delete-bin-line"></i>}
                        onClick={() => {
                            pageProps.pageDelete(pageChange.id)
                            setDisplayEditPagePropertyModal(false)

                        }}
                        danger
                        type='primary'
                    ></Button>
                </div>
            </Modal>
            <Modal
                title="Customize Color"
                visible={displayCustomizeModal}
                onCancel={() => setDisplayCustomizeModal(false)}
                okText='Apply'
                onOk={() => {
                    if (cssVariable) {
                        let root = document.documentElement
                        Object.entries(cssVariable).forEach((value) => root.style.setProperty(value[0], value[1]))
                    }
                    window.less.modifyVars({ ...themes['customTheme'], ...color })
                    localStorage.setItem('styleVariable', JSON.stringify(
                        {
                            lessVariable: color,
                            cssVariable: cssVariable
                        }
                    ))
                }}
            >
                {colorTheme.map((child, index) => {
                    const isLess = child[2] === 'lessVar'
                    return (
                        <Row key={index} gutter={18}>
                            <Col >{child[1]}</Col>
                            <Col style={{ marginLeft: 'auto' }}><ColorPicker colorObj={child[0]} newColor={isLess ? color : cssVariable} setNewColor={isLess ? setColor : setcssVariable} /></Col>
                        </Row>
                    )
                })}

            </Modal>
            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                <Select
                    defaultValue={localStorage.getItem('theme') || 'defaultTheme'}
                    style={{ width: '120px', marginLeft: '30px' }}
                    size='small'
                    onChange={handleThemeChange}
                >
                    <Option value='defaultTheme' >Default</Option>
                    <Option value='contentstackTheme' >Contentstack</Option>
                    <Option value='darkTheme' >Dark</Option>
                    <Option value='customTheme' >Custom</Option>
                </Select>
                {showCustom && <Button
                    size='small'
                    style={{ marginLeft: '5px' }}
                    onClick={(e) => {
                        e.preventDefault()
                        setDisplayCustomizeModal(true)
                    }}
                >
                    <i className="ri-paint-line"></i>
                </Button>}


            </div>
        </div>
    )
}
